import API from '@js/api'
import FACTION_CONF from '@js/config/faction'

const types = {
  SET_BASE_DATA: 'SET_BASE_DATA',
  SET_ROLE_HEROES: 'SET_ROLE_HEROES',
  SET_ANIMATION_SPEED: 'SET_ANIMATION_SPEED',
  SET_TOWN_LIST: 'SET_TOWN_LIST',
}

const state = {
  baseData: {},
  roleHeroes: [],
  animationSpeed: 1,
  townList: [],
}

const getters = {
  baseData (state) {
    return state.baseData
  },
  townLevelData (state) {
    return state.baseData.townLevelData
  },
  townLevelCommand (state) {
    return state.baseData.townLevelCommand
  },
  heroLevelExp (state) {
    return state.baseData.heroLevelExp
  },
  heroLevelCommand (state) {
    return state.baseData.heroLevelCommand
  },
  townList (state) {
    return state.townList
  },
  roleHeroes (state) {
    return state.roleHeroes
  },
  animationSpeed (state) {
    return state.animationSpeed
  },
}

const actions = {
  // 获取用户信息
  getRoleHeroes ({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      try {
        if (state.roleHeroes.length) {
          resolve(state.roleHeroes)
          return
        }
        const roleHeroes = await API.game.getRoleHeroes()
        commit(types.SET_ROLE_HEROES, roleHeroes)
        resolve(roleHeroes)
      } catch (err) {
        console.error(err)
        reject(err)
      }
    })
  },
  // 游戏基础数据
  getGameBaseData ({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await API.game.getBaseData()
        commit(types.SET_BASE_DATA, data)
      } catch (err) {
        console.error(err)
        reject(err)
      }
    })
  },

  async getTownList ({ commit }) {
    try {
      const townList = await API.town.getTowns()
      townList.forEach((t) => {
        t.factionCode = t.faction
        t.faction = FACTION_CONF.FACTIONS_VALUE_NAME[t.factionCode]
        t.factionCn = FACTION_CONF.FACTION_ENG_CH[t.faction]
      })
      commit(types.SET_TOWN_LIST, townList)
      return Promise.resolve()
    } catch (err) {
      console.error(err)
      return Promise.reject(err)
    }
  },

  initAnimationSpeed ({ commit }) {
    const speed = +localStorage.getItem('h3_animation_speed') || 1
    commit(types.SET_ANIMATION_SPEED, speed)
  },
  setAnimationSpeed ({ commit }, speed = 1) {
    localStorage.setItem('h3_animation_speed', speed)
    commit(types.SET_ANIMATION_SPEED, speed)
  },
}

const mutations = {
  [types.SET_BASE_DATA] (state, data) {
    state.baseData = data
  },
  [types.SET_TOWN_LIST] (state, townList) {
    state.townList = townList
  },
  [types.SET_ROLE_HEROES] (state, roleHeroes = []) {
    state.roleHeroes = roleHeroes
  },
  [types.SET_ANIMATION_SPEED] (state, speed = 1) {
    if ([1, 1.25, 1.5, 1.75, 2].includes(speed)) {
      state.animationSpeed = speed
    }
  },
}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}
